var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"app-loader"},[_c('img',{attrs:{"src":require("./../../assets/cndef-loader.gif"),"alt":"Cargando..."}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }